export enum EmailOption {
  All = 'ALL',
  None = 'NONE'
}